import React from 'react';
import EventTracking from 'lib/EventTracking';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';
import CoachingConstants from 'coaching/CoachingConstants';
import CoachingHeading from 'coaching/components/CoachingHeading';

type Props = {
  contactEmail: string | undefined;
  isCoachForm?: boolean;
  eventPrefix: string;
};

export default function CoachingHelpConfirmation({
  isCoachForm,
  eventPrefix,
  contactEmail,
}: Props) {
  React.useEffect(() => {
    EventTracking.trackKey(`${eventPrefix}.submission_confirmation.view`);
  }, [eventPrefix]);

  const helpPageLink = isCoachForm
    ? CoachingConstants.TUTORING_COACH_HELP_ROUTE
    : CoachingConstants.TUTORING_HELP_ROUTE;

  return (
    <React.Fragment>
      <CoachingHeading>Got it!</CoachingHeading>
      <Row size="xxsmall">
        {contactEmail && (
          <Text size="medium" color="graphite">
            We'll get back to you at{' '}
            <Text weight="bold" color="graphite">
              {contactEmail}
            </Text>
            .
          </Text>
        )}
      </Row>
      <Row size="small">
        <Text size="medium" color="graphite">
          {CoachingConstants.COACHING_HELP_HOURS}
        </Text>
      </Row>
      <Row>
        <Text size="medium" color="graphite">
          You may{' '}
          <Link href={helpPageLink} target="_blank" color="koolaid">
            return to Coaching Help
          </Link>{' '}
          or close this page.
        </Text>
      </Row>
    </React.Fragment>
  );
}
